/* eslint-disable complexity */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ModalHeader", {
    enumerable: true,
    get: function() {
        return ModalHeader;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _ModalContext = require("../ModalContext");
const _SrText = require("../../SrText/SrText");
const _Theme = require("../../../contexts/Theme");
const _adminicons = require("../../../admin-icons");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ModalHeader = (param)=>{
    let { children, closeButton = false, backButton = false, noBorder, noTitle = false, intro, supportsMobile = false, onClose } = param;
    const { onHide, title, headerBorder, setHeaderBorder, stickyHeader, scrollable, size, onBack } = (0, _react.useContext)(_ModalContext.ModalContext);
    const { isAdmin, colors, breakpoints } = (0, _Theme.useTheme)();
    (0, _react.useEffect)(()=>{
        if (noBorder != null) {
            setHeaderBorder(!noBorder);
        }
    }, [
        noBorder,
        setHeaderBorder
    ]);
    function getMarginStyle() {
        if (stickyHeader) {
            return "0.5rem 0";
        }
        let bottomMargin = "0px";
        var _intro_length;
        if (((_intro_length = intro === null || intro === void 0 ? void 0 : intro.length) !== null && _intro_length !== void 0 ? _intro_length : 0) === 0) {
            bottomMargin = headerBorder ? "1rem" : "0.5rem";
        } else if (!closeButton && !backButton) {
            bottomMargin = "0.25rem";
        }
        return "1.25rem 0 ".concat(bottomMargin);
    }
    return /*#__PURE__*/ _react.default.createElement("div", {
        style: {
            zIndex: 1
        },
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ]) + " " + "mb-2 header ".concat(headerBorder ? "with-border" : "", " ").concat(isAdmin && scrollable && stickyHeader ? "sticky" : "")
    }, /*#__PURE__*/ _react.default.createElement("div", {
        style: {
            margin: getMarginStyle()
        },
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ]) + " " + "title-row ".concat(supportsMobile ? "title-row--mobile" : "")
    }, !backButton ? null : /*#__PURE__*/ _react.default.createElement("button", {
        onClick: ()=>{
            if (onBack != null) {
                onBack();
            }
        },
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ]) + " " + "back ml-n3"
    }, /*#__PURE__*/ _react.default.createElement("span", {
        "aria-hidden": "true",
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement(_adminicons.RiArrowLeftLine, {
        size: 24,
        color: colors.grayscale[60]
    })), /*#__PURE__*/ _react.default.createElement(_SrText.SrText, null, "Back")), /*#__PURE__*/ _react.default.createElement("h1", {
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ]) + " " + "title ".concat(supportsMobile && "title--mobile")
    }, noTitle ? "" : title), !closeButton && backButton && /*#__PURE__*/ _react.default.createElement("span", {
        style: {
            width: 24
        },
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ])
    }), !closeButton ? null : /*#__PURE__*/ _react.default.createElement("button", {
        onClick: onClose !== null && onClose !== void 0 ? onClose : onHide,
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ]) + " " + "close mr-n3"
    }, /*#__PURE__*/ _react.default.createElement("span", {
        "aria-hidden": "true",
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement(_adminicons.RiCloseFill, {
        size: 24,
        color: colors.grayscale[60]
    })), /*#__PURE__*/ _react.default.createElement(_SrText.SrText, null, "Close"))), intro != null && intro.length > 0 && /*#__PURE__*/ _react.default.createElement("h2", {
        className: _style.default.dynamic([
            [
                "a6f52cb66b5a2916",
                [
                    colors.border,
                    isAdmin ? "center" : "flex-start",
                    !closeButton && !backButton ? "0.5rem" : "0",
                    isAdmin ? "uppercase" : "none",
                    isAdmin ? "500" : "normal",
                    isAdmin ? "12px" : "inherit",
                    isAdmin ? "16px" : "inherit",
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? colors.medium : colors.dark,
                    isAdmin ? "24px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    isAdmin ? "32px" : "inherit",
                    size === "sm" ? "1.125rem" : "1.5rem",
                    size === "sm" ? "1.125rem" : "1.75rem",
                    stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
                    stickyHeader ? "translateY(-1rem)" : "none",
                    stickyHeader ? 0 : 1,
                    stickyHeader ? 0 : "auto",
                    backButton ? "center" : "inherit",
                    breakpoints.md,
                    closeButton ? "flex-end" : "flex-start"
                ]
            ]
        ]) + " " + "intro"
    }, intro), children, /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "a6f52cb66b5a2916",
        dynamic: [
            colors.border,
            isAdmin ? "center" : "flex-start",
            !closeButton && !backButton ? "0.5rem" : "0",
            isAdmin ? "uppercase" : "none",
            isAdmin ? "500" : "normal",
            isAdmin ? "12px" : "inherit",
            isAdmin ? "16px" : "inherit",
            isAdmin ? colors.medium : colors.dark,
            isAdmin ? colors.medium : colors.dark,
            isAdmin ? "24px" : "inherit",
            isAdmin ? "32px" : "inherit",
            isAdmin ? "32px" : "inherit",
            size === "sm" ? "1.125rem" : "1.5rem",
            size === "sm" ? "1.125rem" : "1.75rem",
            stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem",
            stickyHeader ? "translateY(-1rem)" : "none",
            stickyHeader ? 0 : 1,
            stickyHeader ? 0 : "auto",
            backButton ? "center" : "inherit",
            breakpoints.md,
            closeButton ? "flex-end" : "flex-start"
        ]
    }, ".header.__jsx-style-dynamic-selector{-webkit-transition:all 300ms;-moz-transition:all 300ms;-o-transition:all 300ms;transition:all 300ms;padding-left:24px;padding-right:24px}.header.sticky.__jsx-style-dynamic-selector{-webkit-box-shadow:0 1px 0 0 rgba(0,0,0,.1);-moz-box-shadow:0 1px 0 0 rgba(0,0,0,.1);box-shadow:0 1px 0 0 rgba(0,0,0,.1)}.header.with-border.__jsx-style-dynamic-selector{border-bottom:1px solid ".concat(colors.border, "}.title-row.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:").concat(isAdmin ? "center" : "flex-start", ";-webkit-align-items:").concat(isAdmin ? "center" : "flex-start", ";-moz-box-align:").concat(isAdmin ? "center" : "flex-start", ";-ms-flex-align:").concat(isAdmin ? "center" : "flex-start", ";align-items:").concat(isAdmin ? "center" : "flex-start", ";-webkit-transition:all 300ms!important;-moz-transition:all 300ms!important;-o-transition:all 300ms!important;transition:all 300ms!important;position:relative}.title.__jsx-style-dynamic-selector{margin:0;margin-top:").concat(!closeButton && !backButton ? "0.5rem" : "0", ";text-transform:").concat(isAdmin ? "uppercase" : "none", ";font-weight:").concat(isAdmin ? "500" : "normal", ";font-size:").concat(isAdmin ? "12px" : "inherit", ";line-height:").concat(isAdmin ? "16px" : "inherit", ";color:").concat(isAdmin ? colors.medium : colors.dark, ";word-break:break-word}.close.__jsx-style-dynamic-selector,.back.__jsx-style-dynamic-selector{color:").concat(isAdmin ? colors.medium : colors.dark, ";line-height:10px;font-size:").concat(isAdmin ? "24px" : "inherit", ";width:").concat(isAdmin ? "32px" : "inherit", ";height:").concat(isAdmin ? "32px" : "inherit", ";margin-bottom:-.25rem}.close.__jsx-style-dynamic-selector.__jsx-style-dynamic-selector:hover,.back.__jsx-style-dynamic-selector.__jsx-style-dynamic-selector:hover{background:rgba(0,0,0,.05);-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}button.__jsx-style-dynamic-selector{font-size:1.5rem;line-height:1;font-weight:normal;border:0;background:none;cursor:pointer;padding:0;margin:0}.intro.__jsx-style-dynamic-selector{font-weight:700;font-size:").concat(size === "sm" ? "1.125rem" : "1.5rem", ";line-height:").concat(size === "sm" ? "1.125rem" : "1.75rem", ";margin:.5rem 0 ").concat(stickyHeader ? 0 : size === "sm" ? "0.75rem" : "1rem", " 0;-webkit-transition:all 300ms !important, opacity 0ms!important;-moz-transition:all 300ms !important, opacity 0ms!important;-o-transition:all 300ms !important, opacity 0ms!important;transition:all 300ms !important, opacity 0ms!important;-webkit-transform:").concat(stickyHeader ? "translateY(-1rem)" : "none", ";-moz-transform:").concat(stickyHeader ? "translateY(-1rem)" : "none", ";-ms-transform:").concat(stickyHeader ? "translateY(-1rem)" : "none", ";-o-transform:").concat(stickyHeader ? "translateY(-1rem)" : "none", ";transform:").concat(stickyHeader ? "translateY(-1rem)" : "none", ";opacity:").concat(stickyHeader ? 0 : 1, ";height:").concat(stickyHeader ? 0 : "auto", ";text-align:").concat(backButton ? "center" : "inherit", "}@media(max-width:").concat(breakpoints.md, "px){.title--mobile.__jsx-style-dynamic-selector{position:absolute;right:0;left:0;width:100%;text-align:center;z-index:-1}.title-row--mobile.__jsx-style-dynamic-selector{-webkit-box-pack:").concat(closeButton ? "flex-end" : "flex-start", ";-webkit-justify-content:").concat(closeButton ? "flex-end" : "flex-start", ";-moz-box-pack:").concat(closeButton ? "flex-end" : "flex-start", ";-ms-flex-pack:").concat(closeButton ? "flex-end" : "flex-start", ";justify-content:").concat(closeButton ? "flex-end" : "flex-start", "}}")));
};

//# sourceMappingURL=ModalHeader.js.map